/*global ALKMaps*/
(function () {
  "use strict";

  angular
    .module("app")
    .service("routeExceptionsLayerService", routeExceptionsLayerService);

  routeExceptionsLayerService.$inject = [
    "$rootScope",
    "mapService",
    "routeExceptionsLayerFactory",
    "routeExceptionService",
    "userService",
    "_"
  ];

  function routeExceptionsLayerService($rootScope, mapService, routeExceptionsLayerFactory, routeExceptionService, userService, _) {
    var featuresByAvoidFavorID = {};
    var featuresByGroupID = {};
    var mapObj = mapService.getMapFromId();
    var factoryService = null;

    var service = {
      initRouteExceptionsLayerFactory: initRouteExceptionsLayerFactory,
      hasAvoidFavors: hasAvoidFavors,
      showAvoidFavorsLayer: showAvoidFavorsLayer,
      hideAvoidFavorsLayer: hideAvoidFavorsLayer,
      isAvoidFavorsLayerVisible: isAvoidFavorsLayerVisible,
      clearSet: clearSet,
      addSet: addSet,
      isAvoidFavorsSetReady: isAvoidFavorsSetReady,
      getAvoidFavorsSets: getAvoidFavorsSets,
      frameRouteExceptions: frameRouteExceptions
    };

    return service;

    /////////////////////

    function initRouteExceptionsLayerFactory() {
      var styleMap = new ALKMaps.StyleMap({
        "default": new ALKMaps.Style({
          cursor: "pointer",
          strokeColor: "${stroke}",
          strokeWidth: "${strokeWidth}",
          strokeDashstyle: "longdash",
          strokeOpacity: 0.8
        }, {
          context: {
            stroke: (feature) => {
              return feature.attributes.exception.AvoidFavorType === routeExceptionService.FAVOR ? "#00b300" : "#b30000";
            },
            strokeWidth: (feature) => {
              var zoom = mapService.currentZoom();
              var width = 2;
              if (zoom > 12) {
                width = 2;
              }
              if (zoom > 14) {
                width = 4;
              }
              if (zoom > 17) {
                width = 8;
              }
              if (zoom > 19) {
                width = 14;
              }
              return width;
            }
          }
        })
      });

      mapObj.avoidFavorsLayer = new ALKMaps.Layer.Vector("Avoid Favors", {
        styleMap: styleMap,
        visibility: false
      });
      mapObj.map.addLayers([ mapObj.avoidFavorsLayer ]);
      featuresByAvoidFavorID = {};
      featuresByGroupID = {};
      factoryService = routeExceptionsLayerFactory(mapObj.avoidFavorsLayer, featuresByAvoidFavorID, featuresByGroupID);
    }

    function hasAvoidFavors() {
      return userService.hasAvoidFavorsSet();
    }

    function showAvoidFavorsLayer() {
      mapObj.avoidFavorsLayer.setVisibility(true);
      mapObj.savedInfo.showAvoidFavors = true;
    }

    function hideAvoidFavorsLayer() {
      mapObj.avoidFavorsLayer.setVisibility(false);
      mapObj.savedInfo.showAvoidFavors = false;
    }

    function isAvoidFavorsLayerVisible() {
      if (mapObj.avoidFavorsLayer) {
        return mapObj.avoidFavorsLayer.getVisibility();
      } else {
        return false;
      }
    }

    function clearSet(set) {
      var IDs = _.map(set.Links, link => link.AvoidFavorID);
      var feature = _.filter(mapObj.avoidFavorsLayer.features, f => {
        return IDs.indexOf(f.attributes.avoidFavorID) > -1;
      });
      if (feature) {
        mapObj.avoidFavorsLayer.removeFeatures(feature);
        _.forEach(set.groups, group => {
          // delete grouped features
          delete featuresByGroupID[group.GroupID];
          // delete ungrouped features
          _.forEach(group.GroupLinks, link => {
            delete featuresByAvoidFavorID[link.AvoidFavorID];
          });
        });
      }
    }

    function addSet(set) {
      factoryService.addRouteExceptionsToMap(set.groups, set);
    }

    function isAvoidFavorsSetReady() {
      return userService.isAvoidFavorsSetReady();
    }

    function getAvoidFavorsSets() {
      return userService.getAvoidFavorsSets();
    }

    function frameRouteExceptions(set) {
      return factoryService.frameRouteExceptions(set.groups);
    }

    // function getIDsFromExceptions(exceptions) {
    //   var partitioned = _.partition(exceptions, "GroupID");
    //   var groupIDs = _.map(partitioned[0], "GroupID");
    //   var ungroupedIDs = _.map(partitioned[1], "GroupLinks[0].AvoidFavorID");
    //   return {
    //     grouped: groupIDs,
    //     ungrouped: ungroupedIDs
    //   };
    // }
  }
})();




// WEBPACK FOOTER //
// ./app/avoidFavors/avoidFavors.layer.service.js